import { CreateDriverCertificates, UpdateDriverRequestBody } from "../apis";
import { DriverFormValues } from "../components";
import { DriverCertificateType } from "../constants";

export const convertFormDataToUpdateRequestBody = (
  beforeUpdateManagerData: DriverFormValues,
  formData: DriverFormValues
): UpdateDriverRequestBody => {
  const certificates: CreateDriverCertificates = [
    {
      type: DriverCertificateType.DriverLicense,
      reference: formData.driverLicense.reference,
      imagesIds: formData.driverLicense.images.map((image) => image.id)
    },
    {
      type: DriverCertificateType.Insurance,
      reference: formData.insurance.reference,
      imagesIds: formData.insurance.images.map((image) => image.id)
    },
    {
      type: DriverCertificateType.Id,
      reference: formData.idLicense.reference,
      imagesIds: formData.idLicense.images.map((image) => image.id)
    },
    {
      type: DriverCertificateType.Vehicle,
      reference: formData.vehicle.reference,
      imagesIds: formData.vehicle.images.map((image) => image.id)
    }
  ];

  return {
    driverId: formData.id as string,
    phoneNumber:
      beforeUpdateManagerData.phoneNumber.replace(/\s/g, "") !==
      formData.phoneNumber.replace(/\s/g, "")
        ? formData.phoneNumber.replace(/\s/g, "")
        : undefined,
    firstname:
      beforeUpdateManagerData.firstname !== formData.firstname
        ? formData.firstname
        : undefined,
    lastname:
      beforeUpdateManagerData.lastname !== formData.lastname
        ? formData.lastname
        : undefined,
    address:
      beforeUpdateManagerData.address !== formData.address
        ? formData.address
        : undefined,
    birthdate:
      beforeUpdateManagerData.birthdate !== formData.birthdate &&
      formData.birthdate
        ? formData.birthdate.toISOString()
        : undefined,
    imageId:
      formData.image?.id ??
      (beforeUpdateManagerData.image?.id ? null : undefined),
    password: formData.password || undefined,
    repeatPassword: formData.repeatPassword || undefined,
    certificates,
    priority:
      beforeUpdateManagerData.priority !== formData.priority
        ? formData.priority
        : undefined,
    capacity:
      beforeUpdateManagerData.capacity !== formData.capacity
        ? formData.capacity
        : undefined,
    totalCargoVolume: formData.totalCargoVolume,
    totalCargoWeight: formData.totalCargoWeight,
    deliveryZonesIds: formData.deliveryZones.map((zone) => zone.value),
    deliveryCompanyId:
      beforeUpdateManagerData.deliveryCompanyId !== formData.deliveryCompanyId
        ? formData.deliveryCompanyId
        : undefined
  };
};
